import Env from '@opsbase/lib-env';
import Palette from '@opsbase/lib-palette';
import i18n from '@opsbase/lib-i18n';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import moment from 'moment-timezone';
import React from 'react';
import opsbaseLogo from '../../../shared/assets/images/logo-only.svg';
import useReportCSS from './useReportCSS';
const dateFormat = 'ddd, MMM Do YYYY';
const makeMyClasses = (pdf, titleColor) => ({
    title1: {
        fontSize: 36,
        fontWeight: 'bold',
        lineHeight: '40px',
        color: titleColor !== null && titleColor !== void 0 ? titleColor : Palette.primary.main,
    },
    title2: {
        fontSize: 18,
        fontWeight: 'bold',
        lineHeight: '24px',
        color: Palette.Black.main,
    },
    title3: {
        fontSize: 20,
        fontStyle: 'italic',
        color: Palette.LavendarGrey.main,
        lineHeight: '28px',
    },
    footer: {
        textAlign: 'left',
    },
});
export function ReportCoverPage(props) {
    const { subTitle = '', title = '', description = '', pdf = false, pdfDetail = false, titleColor, logoId, } = props;
    const myCss = useReportCSS(pdf, pdfDetail, makeMyClasses, titleColor);
    return (React.createElement("div", { className: myCss.coverpage },
        React.createElement(Vertical, null,
            React.createElement(Pane, { grow: true }, "\u00A0"),
            React.createElement(Pane, null,
                React.createElement("img", { src: logoId ? `${Env.apis.images}/image/` + logoId : opsbaseLogo, width: 100, height: 100, alt: i18n.t('opsbase-logo') })),
            React.createElement(Pane, { classes: { root: myCss.title2 } }, subTitle),
            React.createElement(Pane, { classes: { root: myCss.title1 } }, title),
            !!description && React.createElement(Pane, { classes: { root: myCss.title3 } }, description),
            React.createElement(Pane, { shrink: true, classes: { root: myCss.footer } }, moment().format(dateFormat)),
            pdf && React.createElement(Pane, { grow: true }, "\u00A0"))));
}
export default ReportCoverPage;
